import { Routes } from '@angular/router';
import { Core } from './core/core';

export const routes: Routes = [
  { path: '', component: Core },
  { path: 'eps', loadComponent: () => import('./eps-widget/eps-widget').then((m) => m.EpsWidget) },
  { path: 'privacy', loadComponent: () => import('./privacy/privacy').then((m) => m.Privacy) },
  { path: 'terms', loadComponent: () => import('./terms/terms').then((m) => m.Terms) },
  { path: '**', redirectTo: '' },
];
